import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap cursor-pointer group">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-film-line text-background-50 text-lg"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50 group-hover:text-primary-300 transition-colors">
                {t('site.name')}
              </span>
            </Link>
            <p className="text-foreground-400 text-sm leading-relaxed">
              {t('site.description')}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="space-y-2">
              <Link to="/" className="block text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">{t('nav.home')}</Link>
              <Link to="/category/forbidden-love" className="block text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">{t('nav.category')}</Link>
              <Link to="/about" className="block text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">{t('nav.about')}</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">热门分类</h4>
            <div className="space-y-2">
              <Link to="/category/forbidden-love" className="block text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">{t('category.forbidden_love')}</Link>
              <Link to="/category/social-critique" className="block text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">{t('category.social_critique')}</Link>
              <Link to="/category/classic" className="block text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">{t('category.classic')}</Link>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-foreground-800">
          <p className="text-foreground-500 text-xs text-center">
            {t('footer.disclaimer')}
          </p>
          <p className="text-foreground-500 text-xs text-center mt-2">
            {t('footer.copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
}